import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Fonts, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  wrapper: theme => {
    return (
      {
        flex: 1,
        alignContent: 'center',
        alignItems: 'center',
        paddingBottom: Dimensions.get('window').width < 700 ? '15%' : 10,
        backgroundColor: theme.colors.backgroundColor,
        paddingTop: 10
      }
    )
  },
  container: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  headerTitle: theme => ({
    fontWeight: Fonts.style.h2.fontWeight,
    fontSize: 28,
    paddingBottom: 16,
    paddingLeft: 16,
    lineHeight: 37.4,
    letterSpacing: 0,
    color: theme.colors.headerTitleColor,
  }),
  wrapperContainer: {
    marginBottom: -100,
    paddingBottom: 100,
  },
});
